require('../../common/directives/jv.root-modal.directive');
require('../../common/directives/jv.LoadingButton');
require('../../common/jv.PromiseQueue');
require('./jv.search.save.service');

angular.module('jv.search.save-modal.directive', [
    'jv.common.root-modal.directive',
    'jv.Common.Directives.LoadingButton',
    'jv.Common.PromiseQueue',
    'jv.search.save.service'
])
.controller('jvSearchSaveModalController', [
    '$scope', 'jvSearchSaveService', 'PromiseQueue',
    function($scope, jvSearchSaveService, PromiseQueue) {
        var loading = new PromiseQueue();

        function setState() {
            $scope.state = {
                searchName: '',
                errors: {},
                parameters: angular.copy($scope.searchParameters)
            };
        }

        function showError(type) {
            $scope.state.errors[type] = true;
        }

        function hideErrors() {
            $scope.state.errors = {};
        }

        $scope.save = function() {
            var process;
            hideErrors();
            if (!$scope.state.searchName) {
                return showError('required');
            }
            process = jvSearchSaveService.save($scope.state.searchName, $scope.state.parameters);
            loading.enqueue(process);
            process.then(function() {
                $scope.onSave({
                    name: $scope.state.searchName,
                    parameters: $scope.state.parameters
                });
                $scope.hide();
            }, function(response) {
                if (response && response.status === 409) {
                    showError('duplicate');
                }
                else {
                    $scope.$emit('showMessageBar', {
                        message: i18n['UNABLE_TO_PERFORM_OPERATION'],
                        type: 'error'
                    });
                }
            });
        }

        $scope.isLoading = function() {
            return (loading.length > 0);
        };

        $scope.$watch('show', function(val) {
            if (val) {
                setState();
            }
        });
    }
])
.directive('jvSearchSaveModal', [
    function() {
        return {
            scope: {
                searchParameters: '=',
                hide: '&',
                show: '=',
                onSave: '&'
            },
            controller: 'jvSearchSaveModalController',
            templateUrl: 'modals/saveSearch.html'
        }
    }
]);